export function FunctuionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.712 4.645a3.166 3.166 0 016.288.52V6a1 1 0 11-2 0v-.834a1.166 1.166 0 00-2.315-.192L12.014 9H14a1 1 0 110 2h-2.32l-1.317 7.902A3.707 3.707 0 013 18.294V18a1 1 0 112 0v.293a1.707 1.707 0 003.39.28L9.654 11H8a1 1 0 110-2h1.986l.726-4.355zM19.625 13.22a1 1 0 00-1.406.155L17 14.9l-1.22-1.524a1 1 0 10-1.56 1.25l1.5 1.875-1.5 1.875a1 1 0 101.56 1.25L17 18.1l1.22 1.524a1 1 0 101.56-1.25l-1.5-1.875 1.5-1.875a1 1 0 00-.155-1.406z"
      ></path>
    </svg>
  );
}
